import { useState } from "react";

import { filterBySubject, isSubjectNeutral, SUBJECT_ENGLISH, SUBJECT_MATH, subjectOf } from "./homeUtils";

// 영어 · 수학 페이지 나누기(대표 10/26: 종류 칩으로는 수학 종류가 다 안 담긴다. 포인트만 같이 쓴다).
// 둘 다 하는 아이에게만 탭을 띄운다. 기준은 실제로 받은 과제(할 것 + 끝낸 것)의 종류다.
const useHomeSubject = ({ todoList, finishedList, site }) => {
  const [pickedSubject, setPickedSubject] = useState(null);
  const subjectSet = new Set(
    [...(todoList || []), ...(finishedList || [])].filter((item) => !isSubjectNeutral(item)).map(subjectOf)
  );
  const hasBoth = subjectSet.has(SUBJECT_ENGLISH) && subjectSet.has(SUBJECT_MATH);
  const defaultSubject =
    subjectSet.size === 1 ? [...subjectSet][0] : site === SUBJECT_MATH ? SUBJECT_MATH : SUBJECT_ENGLISH;
  const subject = hasBoth ? pickedSubject || defaultSubject : defaultSubject;

  return {
    subject,
    setSubject: setPickedSubject,
    hasBoth,
    isEnglish: subject === SUBJECT_ENGLISH,
    isMath: subject === SUBJECT_MATH,
    // 한 과목만 하는 아이는 거르지 않는다(지금 화면과 같게)
    todoList: todoList === null ? null : hasBoth ? filterBySubject(todoList, subject) : todoList,
    finishedList: hasBoth ? filterBySubject(finishedList, subject) : finishedList,
  };
};

export default useHomeSubject;
